module.exports = __webpack_public_path__ + "static/img/img3.20ddd53.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cooperation_case/img3.png
// module id = u3H2
// module chunks = 0